<template>
  <section class="strength" id="strength">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <img src="images/ui/strength.svg" alt="Illustration" />
        </div>
        <div class="col-md-6">
          <h5>{{ t('A choice that makes the difference.') }}</h5>
          <h1 class="mb-4">{{ t('Why Choose Us?') }}</h1>
          <p>{{ t('Never get deceived by fancy company history, fake testimonials or useless freebies. Here is the one and only thing that matters.') }}</p>
          <h4>{{ t('"We have all the professional skills that you need with the lowest price guaranteed."') }}</h4>
          <p>{{ t("Why are we so sure? Because we're a disrupting new startup formed by a small group of young and talented people that are not hassled to pay for fancy coffee maker in a high rise building, that's how we keep most of our services free of charge. It's just that simple.") }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.strength {
  img {
    height: 400px;

    @media (max-width: 767.98px) {
      height: 300px;
    }
  }

  h5 {
    color: #666;
  }

  h4 {
    background: linear-gradient(90deg, $primary, #00a0ff);
    border-radius: 0.5rem;
    box-shadow: 0 0.25rem 0.5rem rgb(13 110 253 / 50%);
    color: #fff;
    line-height: 2rem;
    margin: 1.5rem 0;
    padding: 1rem 1.5rem;
  }
}
</style>

<script>
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const { t } = useI18n({
      messages: {
        'en-MY': {
          '"We have all the professional skills that you need with the lowest price guaranteed."': '"We have all the professional skills that you need with the lowest price guaranteed."',
          'A choice that makes the difference.': 'A choice that makes the difference.',
          'Never get deceived by fancy company history, fake testimonials or useless freebies. Here is the one and only thing that matters.': 'Never get deceived by fancy company history, fake testimonials or useless freebies. Here is the one and only thing that matters.',
          'Why Choose Us?': 'Why Choose Us?',
          "Why are we so sure? Because we're a disrupting new startup formed by a small group of young and talented people that are not hassled to pay for fancy coffee maker in a high rise building, that's how we keep most of our services free of charge. It's just that simple.": "Why are we so sure? Because we're a disrupting new startup formed by a small group of young and talented people that are not hassled to pay for fancy coffee maker in a high rise building, that's how we keep most of our services free of charge. It's just that simple."
        },
        'zh-MY': {
          '"We have all the professional skills that you need with the lowest price guaranteed."': '“我们能够有自信地拍胸膛保证，我们能够以市场最低的价格来提供所有您所需要的专业软件开发服务。”',
          'A choice that makes the difference.': '您至关重要的抉择。',
          'Never get deceived by fancy company history, fake testimonials or useless freebies. Here is the one and only thing that matters.': '千万别被花里胡哨的公司历史、虚假的推荐帖子或是无用的赠品所欺骗。我们不需要以此说服您选择我们，我们只需向您阐明一点就已经足够。',
          'Why Choose Us?': '为何选择我们?',
          "Why are we so sure? Because we're a disrupting new startup formed by a small group of young and talented people that are not hassled to pay for fancy coffee maker in a high rise building, that's how we keep most of our services free of charge. It's just that simple.": '或许您会怀疑为何我们能够如此肯定？这是因为我们是由一群才华横溢的年轻人所组成的初创公司，我们并不需要为了承担高档办公室里的咖啡机费用而烦恼，而省下来的经费便成为了我们能够持续免费为您提供大部分服务的资本，仅仅是如此简单而已。'
        },
        'ms-MY': {
          '"We have all the professional skills that you need with the lowest price guaranteed."': '"Kami dapat memberikan servis-servis dengan jaminan harga yang paling rendah."',
          'A choice that makes the difference.': 'Pilihan anda yang menimbulkan perbezaan.',
          'Never get deceived by fancy company history, fake testimonials or useless freebies. Here is the one and only thing that matters.': 'Jangan sekali-kali tertipu dengan latar belakang syarikat, testimoni palsu ataupun barangan percuma yang tidak berguna.',
          'Why Choose Us?': 'Kenapa Pilih Kami?',
          "Why are we so sure? Because we're a disrupting new startup formed by a small group of young and talented people that are not hassled to pay for fancy coffee maker in a high rise building, that's how we keep most of our services free of charge. It's just that simple.": 'Kenapa begitu yakin? Sebab kami adalah satu syarikat permulaan yang dibentuk oleh sekelompok warga muda yang berbakat. Kami tidak perlu risau dengan bayaran mesin kopi dalam pejabat mewah, jadi, kami dapat bagikan balik servis kami secara percuma. Semudah itu sahaja.'
        }
      }
    });

    return { t };
  }
};
</script>
